import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { insertNewLine } from '@/utils';
import Image from '../ContentfulImage';
import Video from '../BrightcoveVideo';
import Section from '../Section';
import media from '../../styles/media.style';

const Contents = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const ImageContainer = styled.div`
  width: 100%;
`;

const Texts = styled.div`
  max-width: 800px;
  text-align: center;
  width: 100%;
`;

const Title = Texts.extend`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.13;
  letter-spacing: 0.4px;
  margin-top: 25px;

  ${media.tabletL`
    font-size: 48px;
    line-height: 1;
    letter-spacing: 0.6px;
    margin-top: 40px;
  `};
`;

const Date = styled.div`
  font-weight: bold;
  margin-top: 10px;
`;

const Location = styled.div`
  font-weight: bold;
  margin-top: 10px;
`;

const Description = Texts.extend`
  margin-top: 15px;
  white-space: pre-wrap;

  ${media.tabletL`
    margin-top: 30px;
  `};
`;

const MarkdownStyle = styled.div`
  > p {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.6px;

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.39;
      letter-spacing: 0.1px;
    `};
  }
`;

const OverviewSection = ({ entryId, heroVideo, heroImage, title, date, location, description }) => (
  <Section id={entryId} options={{ inner: { locked: true }, content: { locked: true } }}>
    <Contents>
      {(heroVideo || heroImage) && (
        <ImageContainer>
          {heroVideo ? (
            <Video {...heroVideo} />
          ) : (
            <Image src={heroImage} options={{ w: '100%', size: [560, 900, 1060] }} />
          )}
        </ImageContainer>
      )}

      <Title dangerouslySetInnerHTML={{ __html: title }} />
      {date && <Date>{date}</Date>}
      {location && <Location>{location}</Location>}
      <Description>
        {insertNewLine({ key: 'overview-section', description, component: MarkdownStyle })}
      </Description>
    </Contents>
  </Section>
);

OverviewSection.defaultProps = {
  entryId: undefined,
  heroVideo: undefined,
  heroImage: undefined,
  title: undefined,
  date: undefined,
  location: undefined,
  description: undefined,
};

OverviewSection.propTypes = {
  entryId: PropTypes.string,
  heroVideo: PropTypes.shape(),
  heroImage: PropTypes.shape({
    title: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  title: PropTypes.string,
  date: PropTypes.string,
  location: PropTypes.string,
  description: PropTypes.string,
};

export default OverviewSection;



// WEBPACK FOOTER //
// ./src/components/Article/OverviewSection.js